<template>
  <div id="app">
    <router-view/>
    <footer id="footer">
      <div class="container">
        <div class="row d-flex justify-content-center text-center text-md-left">
          <div class="col-sm-12 col-md-auto d-flex justify-content-center align-items-center">
            <div class="footer-logo mr-0 mr-md-5 mb-4 mb-md-0">
              <img v-lazy="'/static/img/alfa-logo.png'" alt="Alfa">
              <div class="claim">Qualität für's Handwerk</div>
            </div>
          </div>
          <div class="col-sm-6 col-md-3 mb-4 mb-sm-0">
            <div class="footer-heading">
              <span>Impressum</span>
            </div>
            <div>Alfa GmbH</div>
            <div>Ferdinand-Porsche-Str. 10</div>
            <div>73479 Ellwangen</div>
          </div>
          <div class="col-sm-6 col-md-3">
            <div class="footer-heading">
              <span>Kontakt</span>
            </div>
            <div>kontakt@alfa-direkt.de</div>
            <div>07961 / 5790 - 0</div>
          </div>
          <div class="col-sm-6 col-md-3">
            <div class="footer-heading">
              <span><router-link :to="{ name: 'Datenschutz' }">Datenschutz</router-link></span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
  @import "src/assets/scss/bootstrap.scss";

  .bold {
    font-weight: 600;
  }

  header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    #logo {
      position: absolute; 
      left: 0; 
      top: -6px;
      padding: 15px 25px; 
      background: #fff;
      border-bottom-right-radius: 20px;
      &:hover, &:focus, &:active {
        text-decoration: none;
      }
      .claim {
        padding-top: 5px;
        font-size: 14px;
        font-weight: 600;
        color: black;
      }
    }
  }
  #footer {
    padding: 2rem 0;
    background-color: #eee;
    .footer-heading {
      margin-bottom: .5rem;
      font-size: 1.1rem;
      font-weight: 600;
    }
    .footer-logo {
      text-align: center
    }
    .claim {
      margin-top: 5px;
      font-weight: 700;
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue